import './expanded-header.css';
import logo from '../../../assets/images/svg/logo.svg';

export const ExpandedHeader = () => {
	const navigateToHomePage = () => {
		window.open('https://healthbegins.org/', '_blank');
	};

	return (
		<div className='w-100 flex-column'>
			<div className='header-1 pl-[5rem] w-100 flex items-center'>
				<img
					onClick={navigateToHomePage}
					src={logo}
					alt=''
					className='h-[3.5rem] w-[10.8rem] cursor-pointer'
				/>
			</div>
			<div className='pl-[5rem] pr-[3rem] py-[6.3rem] bg-[#165E97] text-white'>
				<div className='heading-label font-montserrat font-light'>
					The Return on Investment (ROI) Calculator
				</div>
				<div className='sub-heading-label font-light font-montserrat'>
					for Healthcare Partnerships to Address Social Needs
				</div>
			</div>
		</div>
	);
};
